/**
 * @class Defines an authentification object.
 */
export class AuthentificationModel {
  /**
   * @constructor Creates an instance of an authentification object built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    this.accessToken = bo.access_token;
    this.refreshToken = bo.refresh_token;
  }
}
